<template>
    <span class="text-white text-center flex flex-col font-bold text-xs pl-1 w-10 lg:w-6">
        <span class="my-auto">{{ selection.start_number }}</span>
    </span>

    <span class="flex text-white flex-col justify-center p-1 pl-0 w-0 fold:w-14" v-if="selection.silk_image_path !== 'No Image'">
        <span class="p-1 pl-0 w-14 h-14 hidden fold:flex items-center justify-center">
            <img class="w-10" :src="selection.silk_image_path" />
        </span>
    </span>

    <span class="flex justify-center text-white p-2 w-full flex-col">
            <span class="text-xs text-white flex">{{ selection.start_time ?? '' }}</span>
            <span class="text-[12px] sm:text-base mt-1 flex fold:mr-1 whitespace-nowrap font-bold w-fit relative" :class="[selection.jockey?.team ? 'text-white' : 'text-racing-stars-yellow']">
                <p class="pr-[6px]">{{ selection.start_number }}</p> 
                <p>{{ selection.horse ? selection.horse.name : 'Reserve' }}</p>
                <p v-if="isBoosted" class="md:hidden text-xs text-white flex justify-start ml-1 overflow-hidden">x{{ getMultiplier }}</p>
                <span v-if="isBoosted" class="my-auto flex relative">
                    <LightningBoltIcon class="hidden md:flex ml-1 w-6 text-white mb-2"/> 
                    <p class="hidden md:flex text-xs absolute -top-2 -right-4 text-white">x{{ getMultiplier }}</p>
                </span>
            </span>
            <span class="flex text-xs mt-1">
                <span v-if="selection.jockey" class="mr-2">J: {{ selection.jockey.name }}</span>
                <span v-if="selection.trainer">T: {{ selection.trainer.name ?? '' }}</span>
            </span>
    </span>

    <span class="flex justify-center my-auto pr-2 md:pr-3 md:p-1 text-center">
        <!-- <span v-if="isBoosted" class="my-auto flex">
            <p class="text-xs text-purple-700 font-bold mr-2 p-2 py-1 border rounded-full bg-racing-stars-yellow border-racing-stars-yellow">x{{ getMultiplier }}</p>
        </span> -->
        <span v-if="hasResult(selection)" :class="getStyles(selection).border" class="border-transparent text-white pr-2 rounded-b w-12 md:w-24 text-center align-middle uppercase text-[10px] text-xs md:text-sm my-auto">
            <strong v-if="isBoosted">{{ getPoints(selection) * getMultiplier }} Points</strong>
            <strong v-else>{{ getPoints(selection) }} Points</strong>
        </span>
        <!-- <span class="dark:bg-purple-800 text-gray-300 rounded-md text-xs lg:text-sm text-center cursor-pointer my-auto border-2 border-black mr-1 lg:whitespace-nowrap" v-if="isBoosted && hasResult(selection) === false">
            <strong class="p-2 pt-1">Remove</strong>
            <p class="text-xs text-purple-700 font-bold border bg-racing-stars-yellow border-racing-stars-yellow rounded-md rounded-t-none">x{{ getMultiplier }}</p>
        </span>
        <span class="dark:bg-purple-800 text-gray-300 p-2 rounded-md text-xs lg:text-sm text-center cursor-pointer my-auto border-2 border-black mr-1 lg:whitespace-nowrap" v-else-if="hasResult(selection) === false">
            <strong>Boost</strong>
        </span> -->
        <span :class="getStyles(selection).styles" class="p-1 rounded w-8 md:w-fit lg:h-8 text-center text-xs font-bold my-auto align-bottom h-full" v-if="hasResult(selection)"><p class="align-middle my-1">{{ getPosition(selection)}}</p></span>
        <span class="ark:text-white px-0 my-auto rounded-t w-10 text-center font-bold pr-2 text-xs lg:text-sm" v-else>{{ getOdds(selection.forecast_odds_description) }}</span>
        <span class="bg-racing-stars-yellow text-gray-900 p-2 rounded-md text-xs lg:text-sm text-center cursor-pointer my-auto border-2 border-black mr-1" @click="changeSelection(selection)" v-else><strong>Change</strong></span>
    </span>
</template>

<script>
    import {computed, watchEffect, ref, onMounted} from "vue";
    import { LightningBoltIcon, PlusIcon } from '@heroicons/vue/outline'

    export default {
        props: {
            selection: {
                type: Object,
                default: {}
            },
            results: {
                type: Object,
                default: {}
            },
            selectedBooster: {
                type: Object,
                default: {}
            },
            user: {
                type: Object,
                default: {}
            },
            team: {
                type: String,
                default: ''
            },
        },

        emits: ['changeSelection'],

        setup(props, { emit }) {
            const userBoosters = ref(0)
            const showBoostBetModal = ref(false)


            const changeSelection = (selection) => {
                emit('changeSelection', selection)
            }

            const changeBooster = (booster, runner) => {
                props.selectedBooster.booster = booster;
                props.selectedBooster.runner = runner;

                emit('changeBooster', props.selectedBooster)

                axios.post(route('api.bet.applyBoost'), {
                    meeting_id : props.selection.race.meeting_id,
                    boost_type : booster.tag,
                    runner : runner,

                }).then(response => {
                    if (response.status === 200) {
                        // Add style for the newly boosted runner
                        props.selection.boost_applied_to = runner;
                        props.selection.multiplier = booster.tag;
                    } else {

                    }
                })

                // Required otherwise the modal will not popular with boost options
                props.selectedBooster.booster = 0;
                props.selectedBooster.runner = 0;

                showBoostBetModal.value = false
            }

            const hasResult = (selection) => {
                let hasResult = false

                Object.keys(props.results).forEach(key => {
                    if (props.results[key].runner_id === selection.id) {
                        hasResult = true
                    }
                })

                return hasResult
            }

            const isBoosted = computed(() => {
                let boosted = false

                if (props.selection.boost_applied_to == props.selection.id) {
                        boosted = true
                    }

                return boosted
            })


            const getMultiplier = computed(() => {
                let multiplier = false

                if (props.selection.boost_applied_to == props.selection.id) {
                    multiplier = props.selection.multiplier
                }

                return multiplier
            })

            const removeBooster = () => {
                axios.post(route('api.bet.clearBoost'), {
                    meeting_id : props.selection.race.meeting_id,
                }).then(response => {
                        if (response.status === 200) {
                            props.selection.boost_applied_to = 0;
                        }
                    }
                )
            }

            const getBoosters = () => {
                axios.get(route('api.boosters.get'))
                    .then(response => {
                            userBoosters.value = response.data
                        }
                    );
            }

            const getPoints = (selection) => {
                let points = 0

                Object.keys(props.results).forEach(key => {
                    if (props.results[key].runner_id === selection.id) {
                        points = props.results[key].points
                    }
                })

                return points
            }

            const getPosition = (selection, ordinal = true) => {
                let position = 0

                Object.keys(props.results).forEach(key => {
                    if (ordinal) {
                        if (props.results[key].runner_id === selection.id) {
                            position = props.results[key].race_outcome_description
                        }
                    } else {
                        if (props.results[key].runner_id === selection.id) {
                            position = props.results[key].position
                        }
                    }
                })

                return position
            }

            const getStyles = (selection) => {

                let classes = 'dark:bg-gray-600 text-white'
                let borderClass = 'border-transparent'

                let position = getPosition(selection, false)
                let points = getPoints(selection) !== 0

                if (position === 1 && points) {
                    borderClass = 'border-yellow 800'
                    classes = 'bg-gradient-to-br from-yellow-300 to-yellow-600 text-black align-middle'
                }


                if (position === 2 && points) {
                    borderClass = ''
                    classes = 'bg-gradient-to-br from-gray-300 via-gray-200 to-gray-300 text-gray-800'
                }

                if (position === 3 && points) {
                    borderClass = 'border-yellow-700'
                    classes = 'bg-gradient-to-br from-yellow-700 via-yellow-600 to-yellow-700 text-gray-800'
                }

                if (position === 4 && points) {
                    borderClass = 'border-gray-800'
                    classes = 'bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 text-white'
                }

                return {
                    styles: classes,
                    border: borderClass
                }
            }

            onMounted(() => {
                getBoosters()

                // print to console the value of selection
                console.log(props.selection)

                Echo.private('notifications.' + props.user.id)
                    .listen('BoostPlaced', () => {
                        props.selection.boost_applied_to = 0;
                        props.selection.multiplier = 0;

                        getBoosters()
                    });

                Echo.private('notifications.' + props.user.id)
                    .listen('BoostRemoved', () => {
                        getBoosters()
                    });
            })

            return {
                changeSelection,
                hasResult,
                isBoosted,
                getMultiplier,
                getPoints,
                getPosition,
                getStyles,
                removeBooster,
                changeBooster,
                getBoosters,
                userBoosters,
                showBoostBetModal,
            }
        },

        components: {
            LightningBoltIcon,
            PlusIcon,
        },

        data() {
            return {
                boosters:  [
                    {"name" : "Double Points", "tag" : "2", "db_tag" : "times_two_multiplier", "img" : "/images/boosts/double-points.svg"},
                    {"name" : "Triple Points", "tag" : "3", "db_tag" : "times_three_multiplier", "img" : "/images/boosts/triple-points.svg"},
                    {"name" : "5x Points", "tag" : "5", "db_tag" : "times_five_multiplier", "img" : "/images/boosts/quintuple-points.svg"},
                    {"name" : "10x Points", "tag" : "10", "db_tag" : "times_ten_multiplier", "img" : "/images/boosts/decuple-points.svg"},
                    {"name" : "(Coming Soon)", "tag" : "DoubleSelection", "db_tag" : "double_runner", "img" : "/images/boosts/double-runner.svg"}
                ],
            };
        },

        methods: {
            getOddsDescription(oddsDescription) {
                // If oddsDescription has no value return 'no odds'.
                if (!oddsDescription)
                    return 'No Odds';

                // If the api returns 'Evs' for probability return the same.
                else if (oddsDescription === 'Evs')
                    return oddsDescription;

                // If showPercentage is toggled convert given description to percentage and return.
                if (this.showPercentage) {
                    const oddsSplit = oddsDescription.split('/');

                    return parseFloat((Number(oddsSplit[1]) / (Number(oddsSplit[1]) + Number(oddsSplit[0])) * 100).toPrecision(2)) + "%";
                }

                // If show percentage is not toggled return oddsDescription as a fraction.
                return oddsDescription;
            },
        }
    }
</script>
